<template>
    <common-promise class="detail" :promise="queryIssueDetail">
        <div class="detail__left">
            <div class="detail__left__title">{{ article.title }}</div>
            <div class="detail__left__num">
                <span>{{ article.inTime + '  ·  回答' }}</span>
                <span>{{ article.commentCount + '  ·  查看' }}</span>
                <span>{{ article.view }}</span>
                <edit-btn v-if="article.userId" :detail="article"></edit-btn>
            </div>
            <div class="detail__left__line"></div>
            <div class="detail__left__box">
                <div class="tui-editor-contents content" v-html="article.content"></div>
                <!-- <up-btn :id="article.id" :num="article.upNum"></up-btn> -->
            </div>
            <div class="detail__left__discuss">
                <span>{{ article.commentCount + '条回答' }}</span>
            </div>
            <div v-for="item in article.comments" :key="item.id">
                <discuss-content :issue="item" is-markdown @delete="deleteComment"> </discuss-content>
            </div>
            <div v-if="login" class="detail__left__bottom">
                <div v-show="!showInput" class="anwserBtn" @click="showInput = !showInput">写回答</div>
                <div v-show="showInput">
                    <div class="change" @click="changeEditor">
                        {{ editor ? '切换markdown编辑器' : '切换富文本编辑器' }}
                    </div>
                    <md-editor
                        v-model="textarea"
                        :upload="uploadImg"
                        height="200px"
                        :is-html="editor"
                        hide-mode-switch
                    ></md-editor>
                    <div class="btn" @click="push">发布</div>
                </div>
            </div>
            <div v-else class="detail__left__login">
                <span class="blue" @click="onLogin">登录</span>
                <span>后评论</span>
            </div>
        </div>
        <div class="detail__right">
            <user-card
                v-if="article.topicUser"
                class="detail__right__user"
                :author="article.topicUser.username"
            ></user-card>
            <card title="所属标签" card-type="tags" :list="article.tags"></card>
        </div>
        <page-scroll-top></page-scroll-top>
    </common-promise>
</template>

<script>
import UserCard from '../../../components/base/user-card';
import Card from '../../../components/base/card';
import EditBtn from '../../../components/base/edit-btn';
import DiscussContent from '../../../components/base/discuss-content';
import { dateStringify } from '@isyscore/utils/date';
import CommonPromise from '../../../components/common/common-promise';
import PageScrollTop from '../../../components/page/page-scroll-top';
import { error } from '../../../utils/message';
import { queryIssueDetail, create } from '../service';
import { upload } from '../../../service/user';
import MdEditor from '../../../components/base/markdown-editor';
import { markdownRender } from '@/utils/markdown-render';
import Toc from '@/classes/toc.class';

export default {
    components: {
        PageScrollTop,
        CommonPromise,
        UserCard,
        Card,
        MdEditor,
        DiscussContent,
        EditBtn
        // UpBtn
    },

    data() {
        return {
            textarea: '',
            article: {},
            login: false,
            editor: false,
            showInput: false,
            buttonShow: false
        };
    },

    watch: {
        '$store.state.user.userInfo': {
            handler(value) {
                if (value.token) {
                    this.login = true;
                } else {
                    this.login = false;
                }
            },
            deep: true,
            immediate: true
        },

        '$store.state.user.time': {
            handler(value) {
                this.queryIssueDetail();
            },
            deep: true
        }
    },

    methods: {
        async queryIssueDetail() {
            try {
                this.article = await queryIssueDetail(this.$route.query.id);
                const toc = new Toc();
                if (this.article.isMarkdown) this.article.content = markdownRender(this.article.content, { toc });
            } catch (err) {
                return error(err);
            }

            this.article.inTime = dateStringify(this.article.inTime, 'YYYY-M-D');
        },

        async push() {
            if (this.textarea.length === 0) return;

            //兼容老数据
            if (this.editor) {
                this.textarea = this.textarea + '<quill-editor-html-text>';
            } else {
                this.textarea = this.textarea + '<md-editor-html-text>';
            }

            let res;

            try {
                res = await create({
                    content: this.textarea,
                    topicId: this.$route.query.id
                });
            } catch (err) {
                return error(err);
            }

            this.textarea = '';
            await this.queryIssueDetail();
        },

        async uploadImg(blob) {
            let imgUrl;
            let formdata = new FormData();
            formdata.append('file', blob);
            formdata.append('type', 'image');
            const res = await upload(formdata);
            imgUrl = res.urls[0];
            return imgUrl;
        },

        changeEditor() {
            this.editor = !this.editor;
        },

        deleteComment(res) {
            this.queryIssueDetail();
        },

        onLogin() {
            this.$router.push({ name: '登录', query: { from: this.$route.fullPath } });
        }
    }
};
</script>

<style lang="scss" scoped>
.detail {
    width: 1200px;
    margin: 60px auto 118px;
    display: flex;
    justify-content: space-between;
    &__left {
        width: 784px;
        &__login {
            height: 81px;
            background: #f6faff;
            border-radius: 1px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 400;
            margin-top: 24px;
            color: #999999;
            .blue {
                margin-right: 5px;
                cursor: pointer;
            }
        }
        &__title {
            width: 100%;
            font-size: 24px;
            font-weight: 600;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 24px;
        }
        &__num {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-bottom: 23px;
        }
        &__line {
            width: 100%;
            height: 1px;
            background: #dddddd;
            margin-bottom: 61px;
        }
        &__box {
            padding-bottom: 101px;
            margin-bottom: 23px;
            border-bottom: 1px solid #dddddd;
            .content {
                border: none !important;
            }
        }
        &__discuss {
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #666666;
            span {
                color: #047aff;
                margin-right: 5px;
                margin-bottom: 63px;
            }
        }
        &__bottom {
            margin-top: 30px;
        }
        .discuss {
            &__box {
                width: 100%;
                padding: 24px;
                background: #f6faff;
                border-radius: 2px;
            }
        }
    }
    &__right {
        &__user {
            margin-bottom: 30px;
        }
        ::v-deep .card {
            background: #ffffff;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 1px;
        }
    }
    .anwserBtn {
        cursor: pointer;
        width: 786px;
        height: 80px;
        background: #047aff;
        border-radius: 2px;
        text-align: center;
        line-height: 80px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }
    .btn {
        width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #047aff;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        cursor: pointer;
        margin-top: 25px;
        float: right;
    }
    .change {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        text-align: right;
        margin-bottom: 24px;
        cursor: pointer;
        &:hover {
            color: #047aff;
        }
    }
}

.content {
    ::v-deep {
        ul {
            list-style: disc;
        }
        ol {
            list-style: decimal;
        }
        ul,
        ol {
            padding-left: 2em;
        }
    }
}
</style>
